export const SET_LOADING = "SET_LOADING";
export const TOGGLE_SNACKBAR = "TOGGLE_SNACKBAR";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const UPDATE_TABLE_ITEMS = "UPDATE_TABLE_ITEMS";
export const SET_HAS_LOGGED_USER = "SET_HAS_LOGGED_USER";
export const SET_NO_HAS_LOGGED_USER = "SET_NO_HAS_LOGGED_USER";
